
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class PushNotifyConfigDialog extends Serenity.EntityDialog<PushNotifyConfigRow, any> {
        protected getFormKey() { return PushNotifyConfigForm.formKey; }
        protected getIdProperty() { return PushNotifyConfigRow.idProperty; }
        protected getLocalTextPrefix() { return PushNotifyConfigRow.localTextPrefix; }
        protected getNameProperty() { return PushNotifyConfigRow.nameProperty; }
        protected getService() { return PushNotifyConfigService.baseUrl; }
        protected getDeletePermission() { return PushNotifyConfigRow.deletePermission; }
        protected getInsertPermission() { return PushNotifyConfigRow.insertPermission; }
        protected getUpdatePermission() { return PushNotifyConfigRow.updatePermission; }

        protected form = new PushNotifyConfigForm(this.idPrefix);

    }
}